<script setup lang="ts">
import { icons } from "@/helpers";
import IconReload from "@/assets/icons-svg/icon-reload.svg";
import { DxTextBox, DxButton } from "devextreme-vue";
import { getCurrentInstance } from "vue";

type Props = {
  title: string;
  button?: string;
  reload?: boolean;
  ocultarPesquisa?: boolean;
};

const app = getCurrentInstance()
const { $vistra } = app!.appContext.config.globalProperties

type Emits = {
  button: () => void;
  search?: (payload: Event) => void;
  reload?: () => void;
};

defineProps<Props>();
defineEmits<Emits>();
</script>

<template>
  <div class="w-full flex items-center justify-between my-6">
    <span id="wrapperTitle" class="text-md text-gray-500 dark:text-white">
      {{ title }}
    </span>

    <div id="wrapperButtonSearch" class="flex items-center ml-5 gap-6">
      <DxTextBox
        v-if="!ocultarPesquisa"
        class="w-72"
        mode="search"
        :placeholder="$vistra.globalize('pesquisar')"
        @value-changed="(target: Event) => $emit('search', target)"
        value-change-event="keyup"
      />

      <DxButton
        v-if="reload"
        @click="$emit('reload')"
        class="ml-6 px-3 border border-solid border-primary-500 bg-transparent hover:bg-primary-100 rounded"
      >
        <span class="text-primary-500">
          <component :is="IconReload" />
        </span>
      </DxButton>

      <DxButton
        v-if="button"
        @click="$emit('button')"
        :text="button"
      />

      <slot name="moreItens">

      </slot>
    </div>
  </div>
</template>

<style lang="scss">
@media (max-width: 640px) {
  #wrapperTitle {
    @apply w-[50%] #{!important};
  }
  #wrapperButtonSearch {
    @apply w-[50%] #{!important};
  }
}
</style>